import { render, staticRenderFns } from "./CourierSelectDialog.vue?vue&type=template&id=13d9978e&"
import script from "./CourierSelectDialog.vue?vue&type=script&lang=js&"
export * from "./CourierSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports